import React from 'react';
import { useStackedTable } from '../../hooks/useStackedTable';

/**
 * <table> que en el celular se muestra como tarjetas (ver useStackedTable).
 * Sirve para tablas que se renderizan dentro de un .map, donde no se puede
 * llamar al hook directamente, y para tablas de styled-components
 * (`<StyledTable as={StackedTable} stack={...}>`). `stack` recibe las mismas
 * opciones del hook.
 */
const StackedTable = ({ stack, className, children, ...tableProps }) => {
    const stacked = useStackedTable(stack);
    const classes = [className, stacked.className].filter(Boolean).join(' ') || undefined;
    return (
        <table ref={stacked.ref} className={classes} {...tableProps}>
            {children}
        </table>
    );
};

export default StackedTable;
